﻿import clsx from "clsx";
import { useCallback } from "react";
import {
    Routes,
    Route,
    Navigate,
    Outlet
} from "react-router-dom";
import Sidenav, { MenuItem } from "../shared/components/Sidenav";
import { ErrorContainer } from "../shared/pages/ErrorContainer";
import { useAppSelector, useThunkDispatch } from "../store";
import { setMenuIsExpanded as setMenuIsExpandedAction } from "../store/app/actions";
import { loadStoryline as loadStorylineAction } from "../store/storyline/actions";
import { RenderStoryline, useViewerState } from "../viewer";
import SidenavMiniMap from "../viewer/SidenavMiniMap/SidenavMiniMap";
import Users from "./Users/Users";
import Roles from "./Roles/Roles";
import RequiresTags from "../shared/components/RequiresTags";
import Groups from "./Groups/Groups";
import Plugins from "./Plugins/Plugins";

export const menuItems: MenuItem[] = [{
    name: "administration",
    title: "Administration",
    children: [
        {
            name: "users",
            title: "Users",
            description: "Manage users",
            icon: {
                type: "BuiltIn",
                content: "person"
            },
            url: "/admin/users",
            requiredTags: [["users::read"]]
        },
        {
            name: "roles",
            title: "Roles",
            description: "Manage roles",
            icon: {
                type: "BuiltIn",
                content: "checklist"
            },
            url: "/admin/roles",
            requiredTags: [["roles::read"]]
        },
        {
            name: "groups",
            title: "Groups",
            description: "Manage groups",
            icon: {
                type: "BuiltIn",
                content: "groups"
            },
            url: "/admin/groups",
            requiredTags: [["groups::read"]]
        },
        {
            name: "plugins",
            title: "Plugins",
            description: "Manage plugins",
            icon: {
                type: "BuiltIn",
                content: "extension"
            },
            url: "/admin/plugins",
            requiredTags: [["tenants::read"]]
        }
    ]
}];

function Admin(props) {
    const { menuItems } = props;
    const pageError = useAppSelector(state => state.app.errors.page);
    const dispatch = useThunkDispatch();
    const loadStoryline = useCallback((...params: Parameters<typeof loadStorylineAction>) => dispatch(loadStorylineAction(...params)), [dispatch]);
    const setMenuIsExpanded = useCallback((...params: Parameters<typeof setMenuIsExpandedAction>) => dispatch(setMenuIsExpandedAction(...params)), [dispatch]);
    const { visibilityClasses, ensureCorrectStorylineIsLoaded } = useViewerState(loadStoryline, setMenuIsExpanded);

    return (
        <Routes>
            <Route index element={<Navigate to="/admin/users" />} />
            <Route
                path={`storylines/:id`}
                element={
                    <div className="app-layout admin-page">
                        <Sidenav menuItems={menuItems} activeItemContent={<SidenavMiniMap />} className={clsx(visibilityClasses)} />
                        <div className={clsx("content", visibilityClasses)}>
                            <RenderStoryline loader={ensureCorrectStorylineIsLoaded(loadStoryline)} />
                        </div>
                    </div>

                }
            />
            <Route
                path="/"
                element={
                    <div className="app-layout admin-page">
                        <Sidenav menuItems={menuItems} />
                        <div className="content">
                            <ErrorContainer error={pageError} includeNavBar />
                            <Outlet />
                        </div>
                    </div>
                }
            >
                <Route
                    path="users"
                    element={
                        <RequiresTags tags={[["users::read"]]}>
                            <Users />
                        </RequiresTags>
                    }
                />
                <Route
                    path="roles"
                    element={
                        <RequiresTags tags={[["roles::read"]]}>
                            <Roles />
                        </RequiresTags>
                    }
                />
                <Route
                    path="groups"
                    element={
                        <RequiresTags tags={[["groups::read"]]}>
                            <Groups />
                        </RequiresTags>
                    }
                />
                <Route
                    path="plugins"
                    element={
                        <RequiresTags tags={[["tenants::read"]]}>
                            <Plugins />
                        </RequiresTags>
                    }
                />
            </Route>
        </Routes>
    );
}

export default Admin;